import { render } from "./SectionCarrousel.vue?vue&type=template&id=680594e8&scoped=true"
import script from "./SectionCarrousel.vue?vue&type=script&lang=js"
export * from "./SectionCarrousel.vue?vue&type=script&lang=js"

import "./SectionCarrousel.vue?vue&type=style&index=0&id=680594e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680594e8"]])

export default __exports__